/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  IconButton,
  Button,
  Checkbox,
  Grid,
} from '@material-ui/core';
import { Close, MoreHoriz, Room as RoomIcon, FileCopy as FileCopyIcon } from '@material-ui/icons';
import { getStudentOnClass, createClassroomLink } from '@webapps/business';
import {
  useMutation,
  PaginationNumbers,
  useQuery,
  useAuth,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import { useEffect, useState } from 'react';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import { ROUTES_PATH } from 'config/constants';

const { NX_REDIRECT_URI } = process.env;
  
const ShareClassroom = ({ id, onClose }) => {
  const { classes, css, cx, global, theme: { spacing } } = useStyles(styles);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(true);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [open, setOpen] = useState(false);

  const { addToast } = useToast();

  const {
    data: { content: infoMembers = [], totalElements } = {},
  } = useQuery(getStudentOnClass, {
    key: ['studentOnClass', page, id],
    variables: {
      id,
      status: 'ENROLLED',
      page: page - 1,
      size: 4,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const handleCheckedStudent = (studentId) => {
    if (selectedStudents.some(student => student.id === studentId)) {
      setSelectedStudents(selectedStudents.filter(student => student.id !== studentId));
    } else {
      setSelectedStudents([...selectedStudents, { id: studentId }]);
    }
  };

  const {
    data: dataLink,
    error: errorLink,
    isLoading: isLoadingLink,
    isSuccess: isSuccessLink,
    mutateAsync: mutateUpdateProfileImage,
  } = useMutation(createClassroomLink);

  const handleSubmit = async () => {
    const data = {
      classroom: {
        id
      },
      type: total ? "all" : "partial",
      expirationDate: new Date(new Date().getTime() + 1000 * 60 * 60 * 24),
    }
    if(!total) {
      data.students = selectedStudents
    }

    await mutateUpdateProfileImage({data});
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${NX_REDIRECT_URI}${ROUTES_PATH.SHARE_CLASSROOM.replace(':link', '')}${dataLink?.data?.link}`);
    addToast({
      status: 'success',
      message: 'Lien copié dans le presse-papier',
    });
  };

  useEffect(() => {
    if (isSuccessLink) {
      addToast({
        status: 'success',
        message: 'Votre lien a été créé avec succès',
      });
      setOpen(true);
    }
    if (errorLink) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la création du lien',
      });
    }
  }, [isSuccessLink, errorLink]);

  return (
    <div>
      <div className={classes.allContainer}>
        <p className={classes.allText}>Partager tous les apprenants de la classe</p>
        <Checkbox
          checked={total}
          classes={{
            root: css({
              transform: 'scale(1.5)'
            }),
          }}
          color="primary"
          onChange={(e) => setTotal(e.target.checked)}
          size="medium"
        />
      </div>
      <div className={classes.studentContainer}>
        {infoMembers.map((item, index) => (
        <div
          className={`${css({
            display: 'flex',
            justifyContent: 'space-between',
            cursor: total ? "default" : "pointer",
            padding: spacing(2),
            marginBottom: spacing(2),
            width: '49%',
          })} ${(total || selectedStudents.some(student => student.id === item?.student?.id)) && classes.selectedStudent}`}
          onClick={() => !total && handleCheckedStudent(item?.student?.id)}
        >
          <div className={css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          })}>
            <div>
              <AvatarStudent applicant={item?.student} height={70} width={70} />
            </div>
            <div className={css({ marginLeft: spacing(2) })}>
              <div className={cx(global.title, classes.name)}>
                {item?.student?.firstname} {item?.student?.lastname}
                {/* {info?.verified && (
                <VerifiedUserIcon
                  className={css({ marginLeft: spacing(1) })}
                  color="primary"
                />
              )} */}
              </div>
              <div className={cx(global.infoText, classes.address)}>
                {item?.student?.address?.city && (
                  <>
                    <RoomIcon className={classes.imgAdress} />
                    <div>
                      {item?.student?.address?.city} {item?.student?.address?.cityCode}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <Checkbox
            checked={total || selectedStudents.some(student => student.id === item?.student?.id)}
            disabled={total}
            color="primary"
            onChange={() => handleCheckedStudent(item?.student?.id)}
            size="small"
          />
        </div>
        ))}
      </div>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={4}
        totalCount={totalElements}
      />
      <div style={{display: 'flex'}}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          md={6}
        >
          <Button
            className={css({ borderRadius: '10.0px', width: '95%'})}
            color="primary"
            disableElevation
            onClick={handleSubmit}
            type="submit"
            variant="contained"
          >
            Confirmer
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),

          })}
          item
          md={6}
        >
          <Button
            className={css({ borderRadius: '10.0px', width: '95%'})}
            color="secondary"
            disableElevation
            onClick={onClose}
            type="submit"
            variant="contained"
          >
            Annuler
          </Button>
        </Grid>
      </div>
      <Modal
        open={open}
        onCancel={() => {setOpen(false); onClose();}}
        title="Voici votre lien de partage de classe"
        width={600}
      >
        <div className={classes.copyToClipboardContainer}>
        <div className={cx(global.subTitle, classes.subTitle)}>Appuyez sur le bouton pour copier le lien</div>
        <div className={cx(global.subTitle, classes.subTitle)}>(Votre lien expire dans 24 heures)</div>
        <IconButton className={classes.copyToClipboard} onClick={copyToClipboard} color="primary">
          <FileCopyIcon className={classes.copyToClipboardIcon} /> Copier le lien
        </IconButton>
      </div>
      </Modal>
    </div>
  );
};

const styles = ({spacing}) => ({
  allContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  allText: {
    display: 'inline-block',
    fontSize: '15.00px',
  },
  copyToClipboard: {
    background: '#0060F9',
    color: 'white',
    borderRadius: 10,
    padding: spacing(1, 2, 1, 2),
    marginTop: spacing(2),
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    fontWeight: 600,
    '&:hover': {
      background: '#0060F9',
      color: 'white',
    },
  },
  copyToClipboardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: spacing(2),
  },
  copyToClipboardIcon: {
    marginRight: spacing(1),
'@media only screen and (max-width:1920px)': {fontSize: '15.0px'}, '@media only screen and (max-width:1600px)': {fontSize: '15px'},
  },
  subTitle: {
    width: '100%',
    textAlign: 'center',
  },
  studentContainer: {
    margin: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  selectedStudent: {
    backgroundColor: '#F3F7FF',
    borderRadius: '10px',
  },
  gridContainer: {
    display: 'flex',
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  profilStatus: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(5),
  },
  btnVitrine: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
  },
  progressBar: {
    marginTop: spacing(1),
  },
});

export default ShareClassroom;
  